
























































































































import { Component, Vue } from 'vue-property-decorator';
import { WorkerDetailsModule } from '@/store/modules/workerDetails'
import VerifiableAttribute from '@/components/Shared/VerifiableAttribute.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import WorkerPositionCreate from '@/components/WorkerPositions/WorkerPositionCreate.vue';
import WorkerPositionEdit from '@/components/WorkerPositions/WorkerPositionEdit.vue';
import { WorkerPositionDto } from '@/models/Workers/WorkerPositionDto';

@Component({
  name: 'WorkerPositions',
  components: { VerifiableAttribute, WorkerPositionCreate, WorkerPositionEdit }
})
export default class extends GiganautVue {

    deleteDialog = false;
    deleting = false;
    positionToDelete: WorkerPositionDto | null = null;

    async created() {
       await WorkerDetailsModule.getPositions();
    }

    get loading() {
        return WorkerDetailsModule.loadingPositions;
    }

    get positions() {
        return WorkerDetailsModule.positions;
    }

    confirmDelete(position: WorkerPositionDto) {
        this.positionToDelete = position;
        this.deleteDialog = true;
    }

    async deletePosition() {
        if (!this.positionToDelete) return;
        this.deleting = true;
        await WorkerDetailsModule.deletePosition(this.positionToDelete.id);
        this.deleting = false;
        this.deleteDialog = false;
        this.positionToDelete = null;
    }

}
